var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "width": "84%",
      "height": "auto",
      "is-loc": "center"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [this.setting.popadv && this.setting.popadv.id ? _c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "adv-title"
  }, [_vm._v(" Temporarily suspend permissions ")]), _c('div', {
    staticClass: "adv-content"
  }, [_vm._v(" Your privileges have been temporarily suspended because you used an already verified face for repeated verification ")]), _c('div', {
    staticClass: "btn-confirm",
    class: _vm.faceUidCountdown > 0 && 'gray',
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Verify ")]), _c('div', {
    staticClass: "tip"
  }, [_vm._v(" Next time " + _vm._s(_vm._f("formatHour")(_vm.faceUidCountdown)) + " ")])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };